import React, { useState, useEffect } from 'react';
import './Activities.css';
import { Link } from 'react-router-dom';
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow-right.svg';
import vectorImg from '../../assets/icons/vector.svg';
import { activityService } from '../../services/activityService';

const Activities = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const data = await activityService.getActivities();
        setActivities(data.activities);
      } catch (error) {
        console.error('Ошибка загрузки активностей:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  if (loading) {
    return <div className="activities-loading">Загрузка...</div>;
  }

  return (
    <section className="activities">
      <div className="container">
        <h2 className="activities-title">Чем заняться в парке?</h2>
        <div className="activities-vector">
          <img src={vectorImg} alt="decorative vector" />
        </div>
        <div className="activities-grid">
          {activities.map((activity, index) => (
            <Link 
              to={`/activity/${activity.slug}`} 
              key={activity.id} 
              className="activity-card-link"
              style={{ textDecoration: 'none' }}
            >
              <div className="activity-card">
                <div className="activity-image">
                  <img 
                    src={activity.coverImage || activity.image} 
                    alt={activity.title} 
                  />
                </div>
                
                <div className="activity-content">
                  <div className="activity-header">
                    <h3 className="activity-title">{activity.title}</h3>
                  </div>
                  <p className="activity-description">{activity.description}</p>
                  <button className="activity-arrow">
                    <ArrowIcon />
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Activities;